import { PlanCheckStatus, PlanFinding } from '@core/models/plan-finding.model';

export type PlanFindingsPhase =
  | 'IDLE'
  | 'READING'
  | 'CHECKING'
  | 'READY'
  | 'FAILED'
  | 'UNAVAILABLE';

export interface PlanFindingsState {
  planId: string | null;
  paramId: number | null;
  status: PlanCheckStatus;
  isStale: boolean;
  findings: PlanFinding[];
  /**
   * Whether the server has answered for this plan yet. `status` cannot say: its initial value
   * is `NOT_CHECKED`, which is indistinguishable from a plan that really has never been checked,
   * so reading it before the first response claims something we do not know.
   *
   * Not derived from `phase` either — that returns to `READING` on every routine re-read, and
   * treating a refresh as "we know nothing" would empty the panel each time.
   */
  hasResolved: boolean;
  phase: PlanFindingsPhase;
  /**
   * Bumped by every plan edit. A check captures it when it starts and may only clear
   * `isStale` if it still matches on completion, so an edit landing mid-check is not
   * erased by that check's `isStale: false`.
   */
  editSeq: number;
}

export const initialPlanFindingsState: PlanFindingsState = {
  planId: null,
  paramId: null,
  status: PlanCheckStatus.NOT_CHECKED,
  isStale: false,
  findings: [],
  hasResolved: false,
  phase: 'IDLE',
  editSeq: 0
};
